export const KEYS = {
    TAB: 'Tab',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_LEFT: 'ArrowLeft'
};

export const FOCUSABLE_ELEMENTS_SELECTOR = [
    'a[href]:not([tabindex=\'-1\'])',
    'area[href]:not([tabindex=\'-1\'])',
    'input:not([disabled]):not([tabindex=\'-1\'])',
    'select:not([disabled]):not([tabindex=\'-1\'])',
    'textarea:not([disabled]):not([tabindex=\'-1\'])',
    'button:not([disabled]):not([tabindex=\'-1\'])',
    'iframe:not([tabindex=\'-1\'])',
    '[tabindex]:not([tabindex=\'-1\'])',
    '[contentEditable=true]:not([tabindex=\'-1\'])'
].join(', ');

export const handleTabArrowKeyPress = (event, currentTabId, selector = '[role="tab"]', idAttribute = 'id') => {
    if (event.key !== KEYS.ARROW_RIGHT && event.key !== KEYS.ARROW_LEFT) {
        return null;
    }

    event.preventDefault();
    const tabDirection = event.key === KEYS.ARROW_LEFT ? -1 : 1;
    const tabElements = Array.from(document.querySelectorAll(selector));

    if (!tabElements.length) {
        return null;
    }

    const currentElement = tabElements.find(el => el.getAttribute(idAttribute)?.includes(currentTabId));
    const currentIndex = tabElements.indexOf(currentElement);

    if (currentIndex === -1) {
        return null;
    }

    const nextIndex = calculateNextTabIndex(currentIndex, tabElements.length, tabDirection);
    const nextTabElement = tabElements[nextIndex];
    const nextTabId = nextTabElement.getAttribute(idAttribute);

    return {
        direction: event.key,
        nextTabElement,
        nextTabId,
        currentTabId
    };
};

export const calculateNextTabIndex = (currentIndex, tabCount, tabDirection) => {
    return Math.min(Math.max(currentIndex + tabDirection, 0), tabCount - 1);
};

export const createFocusTrap = (containerRef) => {
    const handleTabKey = (event) => {
        if (event.key !== KEYS.TAB || !containerRef) return;

        const focusableElements = containerRef.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR);
        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        const {activeElement} = document;

        if (event.shiftKey && activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
        } else if (!event.shiftKey && activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
        } else if (!containerRef.contains(activeElement)) {
            event.preventDefault();
            firstElement.focus();
        }
    };

    return {
        activate: () => {
            document.addEventListener('keydown', handleTabKey);
            return handleTabKey;
        },

        deactivate: (handler) => {
            document.removeEventListener('keydown', handler || handleTabKey);
        }
    };
};